import { Geometry } from '@turf/helpers';

const cleanGeometry = (geometry?: Geometry) => {
  if (!geometry) {
    return null;
  }

  if (geometry?.type === 'MultiPolygon' && geometry?.coordinates.length === 1) {
    return {
      ...geometry,
      type: 'Polygon',
      coordinates: geometry.coordinates[0]
    };
  }
  return geometry;
};

export default cleanGeometry;
